// Hook dodania komentarza do pozycji oferty.
// POST /sales-crm/clients/:cid/offers/:oid/positions/:pid/comments

import { axios } from 'api';
import { useMutation, UseMutationOptions } from 'react-query';
import { ICommandResponseError as IError, ICommandResponseSuccess } from 'api/types';

export interface IPostSalesCrmOfferPositionCommentPayload {
  comment: string;
  isVisibleForClient?: boolean;
  fileBase64?: string | null;
  fileName?: string | null;
}

type IResponse = ICommandResponseSuccess & { id?: number };

const postSalesCrmOfferPositionComment = (
  clientId: number,
  offerId: string,
  positionId: number,
  payload: IPostSalesCrmOfferPositionCommentPayload
): Promise<IResponse> =>
  axios.post(
    `/sales-crm/clients/${clientId}/offers/${offerId}/positions/${positionId}/comments`,
    payload
  );

export const usePostSalesCrmOfferPositionComment = (
  clientId: number,
  offerId: string,
  positionId: number,
  options?: UseMutationOptions<IResponse, IError, IPostSalesCrmOfferPositionCommentPayload>
) =>
  useMutation(
    (payload: IPostSalesCrmOfferPositionCommentPayload) =>
      postSalesCrmOfferPositionComment(clientId, offerId, positionId, payload),
    options
  );
